import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  lineTop: theme => ({
    borderTopColor: theme.colors.fillColor,
    borderTopWidth: 1,
    marginTop: 17,
  }),
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    padding: 20,
    shadowColor: Colors.blackThree,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 4,
  }),
  lineBottom: {
    borderBottomColor: Colors.veryLightPinkTwo,
    borderBottomWidth: 1,
  },
  tick: {
    width: 23,
    height: 23,
  },
  statusLogo: {
    marginLeft: 10,
  },
  monthStatusContainer: {
    paddingTop: 15,
  },
  priceTextStyle: theme => ({
    fontSize: 29.1,
    color: theme.colors.textColorThree,
    fontFamily: Fonts.type.VodafoneLt,
    paddingTop: Platform.OS === 'ios' ? 5 : undefined,
  }),
  currencyTextStyle: theme => ({
    fontSize: 29.1,
    color: theme.colors.textColorThree,
    fontFamily: Fonts.type.VodafoneLt,
    paddingTop: Platform.OS === 'ios' ? 5 : undefined,
  }),
  monthTextStyle: theme => ({
    fontSize: 25,
    color: theme.colors.textColorThree,
    fontFamily: Fonts.type.VodafoneLt,
  }),
  yearTextStyle: theme => ({
    ...Fonts.type.bold,
    fontSize: 16.6,
    color: theme.colors.textColorThree,
  }),
  timePeriodTextStyle: {
    fontSize: 16.6,
    color: Colors.smoothGrey,
    fontFamily: Fonts.type.VFFont,
  },
  remainingAmountTextStyle: theme => ({
    fontSize: 16,
    textAlign: 'right',
    color: theme.colors.textColorTwo,
  }),
  remainingAmountStyle: {
    paddingTop: 6,
  },
  icon: {
    marginRight: -2,
  },
  negativeBalanceContainer: {
    alignItems: 'center',
  },
});
